import { Factory } from "lucide-react"
import type { LocalizedText, NotificationRenderer } from "../../types"
import { navigateForAction } from "../actionRoutes"

// resource_type is "declaration" for this type — icon mirrors the sidebar's
// Supplier Studio entry (STUDIO_ICONS_V2["supplier-studio"] in studios.ts /
// the legacy STUDIOS array in MaterialComplianceSidebarGroup.tsx), since
// that's the module that owns declarations, not the MC group icon.
// Payload is untrusted: type-guard before using a field as a param.
export const declarationReadyForReview: NotificationRenderer = {
  icon: Factory,
  accent: "default",
  // Popover rows show only the title (no description), so it needs to carry
  // context on its own: prefer supplier, then filename, then fully generic.
  title: (payload): LocalizedText => {
    if (typeof payload?.supplierName === "string") {
      return {
        key: "NOTIF/DECL_READY/TITLE",
        params: { supplier: payload.supplierName },
      }
    }
    if (typeof payload?.filename === "string") {
      return {
        key: "NOTIF/DECL_READY/TITLE_FILENAME",
        params: { filename: payload.filename },
      }
    }
    return { key: "NOTIF/DECL_READY/TITLE_GENERIC" }
  },
  description: (payload) =>
    typeof payload?.filename === "string"
      ? { key: "NOTIF/DECL_READY/DESC", params: { filename: payload.filename } }
      : { key: "NOTIF/DECL_READY/DESC_GENERIC" },
  cta: "NOTIF/CTA/REVIEW_DECLARATION",
  onAction: navigateForAction,
}
